import { useContext } from 'react';
import { createContext } from 'react';
import { useCssHandles } from '../../../../utils/functions';
import { useSliderLayout } from '../../../slider-layout/SliderLayout/hooks/useSliderLayout';

import { InfoCardProps } from '../@types/InfoCardProps';

export const InfoCardContext = createContext<any>({} as InfoCardProps);

InfoCardContext.displayName = 'InfoCard';
const CSS_HANDLES = [
	'infoCardContainer',
	'infoCardImage',
	'infoCardImageContainer',
	'infoCardCallActionText',
	'infoCardCallActionContainer',
	'infoCardHeadline',
	'infoCardTextContainer',
	'infoCardContainer',
	'infoCardSubhead',
];
export function InfoCardProvider(props: InfoCardProps) {
	const sliderLayout = useSliderLayout();
	const { handles }: any = useCssHandles(
		sliderLayout ? 'vtex-slider-layout-0-x' : 'vtex-store-components-3-x',
		CSS_HANDLES,
		props?.blockClass,
	);
	return <InfoCardContext.Provider value={{ ...props, handles }}>{props.children}</InfoCardContext.Provider>;
}

export function useInfoCard() {
	const context = useContext(InfoCardContext);

	return context;
}
